import { ValidatorFn } from '@angular/forms';

import { INDDFilterI18nServiceConfigResources } from '../ndd-ng-filter-i18n.service';
import { NDDFilterOperatorsByTypes } from './ndd-ng-filter-operators.model';
import {
    INDDFilterLogicalOperator,
    INDDFilterOperator,
    INDDFilterOption,
    INDDFilterProperty,
} from './ndd-ng-filter-state.model';
import { NDDFilterTypes } from './ndd-ng-filter.enum';

export class INDDFilterStartupConfig {
    public resources: INDDFilterI18nServiceConfigResources;
    public defaultLogicalOperator: INDDFilterLogicalOperator;
    public operatorsByType: NDDFilterOperatorsByTypes;
    public logicalOperators: INDDFilterLogicalOperator[];
}

export interface INDDFilterConfig {
    rulesConfig: INDDFilterRuleConfig[];
    logicalOperators?: INDDFilterLogicalOperator[]
    maxCount?: number;
}

export interface INDDFilterRuleConfig {
    type: NDDFilterTypes;
    property: INDDFilterProperty;
    controlConfig?: INDDFilterRuleControlConfig;
    operators?: INDDFilterOperator[];
    options?: INDDFilterOption[];
}

export interface INDDFilterRuleControlConfig {
    string?: INDDFilterRuleControlConfigString;
    numeric?: INDDFilterRuleControlConfigNumeric;
    validators?: ValidatorFn[],
    unit?: string,
}

export interface INDDFilterRuleControlConfigString {
    maxLength?: number;
}
export interface INDDFilterRuleControlConfigNumeric {
    integerMax?: number;
    integerMin?: number;
    decimalDigitsMax?: number;
    decimalDigitsMin?: number;
    showSpinButtons?: boolean;
    format?: INDDFilterRuleControlConfigFormat;
    value?: number;
}

export interface INDDFilterRuleControlConfigFormat {
    format: string;
}
